import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { JobApplicationProvider } from './context/JobApplicationContext';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import Header from './components/Header/Header';
import Dashboard from './components/Dashboard/Dashboard';
import './App.css';

function App() {
  // Read demo mode from environment variable
  const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';
  
  if (isDemoMode) {
    // Demo mode - bypass authentication but still provide AuthProvider for Header
    return (
      <ThemeProvider>
        <AuthProvider>
          <JobApplicationProvider>
            <div className="App">
              <Header />
              <main className="main-content">
                <Dashboard />
              </main>
            </div>
          </JobApplicationProvider>
        </AuthProvider>
      </ThemeProvider>
    );
  }

  // Normal mode with authentication
  return (
    <ThemeProvider>
      <AuthProvider>
        <ProtectedRoute>
          <JobApplicationProvider>
            <div className="App">
              <Header />
              <main className="main-content">
                <Dashboard />
              </main>
            </div>
          </JobApplicationProvider>
        </ProtectedRoute>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;